import { z } from "zod";
import { createEndpoint, createEndpointWithPagination } from "../createEndpoint";
import { HttpClient, QueryParams } from "../httpClient";
import {
    LeadExpertResponseSchema,
    ExpertListLeadsQueryParams,
    CreateExpertLeadInviteRequest,
} from "../schemas/leads-v2";

export function createExpertLeadsV2Api(http: HttpClient, baseUrl: string) {
    const expertBaseUrl = `${baseUrl}/expert/leads-v2`;

    return {
        /**
         * Create a client project invite as the authenticated expert
         * POST /api/v2/expert/leads-v2
         */
        submitLead: createEndpoint<
            z.infer<typeof LeadExpertResponseSchema>,
            CreateExpertLeadInviteRequest,
            QueryParams
        >(http, "POST", "", {
            base: expertBaseUrl,
            responseSchema: LeadExpertResponseSchema,
        }),

        /**
         * List all leads matched to the authenticated expert
         * GET /api/v2/expert/leads-v2
         */
        listLeads: createEndpointWithPagination<
            z.infer<typeof LeadExpertResponseSchema>,
            unknown,
            unknown,
            ExpertListLeadsQueryParams
        >(http, "GET", "", {
            base: expertBaseUrl,
            itemSchema: LeadExpertResponseSchema,
        }),

        /**
         * Get a single lead by ID (must be matched to authenticated expert)
         * GET /api/v2/expert/leads-v2/:id
         */
        getLead: createEndpoint<
            z.infer<typeof LeadExpertResponseSchema>,
            unknown,
            QueryParams,
            { id: number }
        >(http, "GET", "/:id", {
            base: expertBaseUrl,
            responseSchema: LeadExpertResponseSchema,
            params: ["id"],
        }),
    };
}

export type ExpertLeadsV2Api = ReturnType<typeof createExpertLeadsV2Api>;

